import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  faAddressBook,
  faBuilding,
  faCalendarMinus,
  faCalendarPlus,
  faChartLine,
  faCity,
  faCog,
  faFileAlt,
  faHome,
  faIdBadge,
  faMoneyCheckAlt,
  faQuestion,
  faTasks,
  faUsers,
  faUsersSlash,
  faUser,
  faWallet,
  faCalculator,
} from '@fortawesome/free-solid-svg-icons';
import { DataService } from 'src/app/service/data.service';
import { Observable } from 'rxjs';
import { UsuarioService } from 'src/app/service/usuario.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { KeycloakProfile } from 'keycloak-js';

@Component({
  selector: 'menu-internas-pagina',
  templateUrl: './menu-internas-pagina.component.html',
  styleUrls: ['./menu-internas-pagina.component.scss'],
})
export class MenuInternasPaginaComponent implements OnInit {
  menus: any[] = [];
  menuPage: any = [];
  usuario$: Observable<any> = new Observable();
  permitirConfig = false;
  listIcons: any = {
    faHome,
    faCalendarMinus,
    faFileAlt,
    faAddressBook,
    faMoneyCheckAlt,
    faChartLine,
    faCog,
    faQuestion,
    faBuilding,
    faCalendarPlus,
    faUsers,
    faIdBadge,
    faUsersSlash,
    faCity,
    faTasks,
    faUser,
    faWallet,
    faCalculator,
  };
  visao = 'cedente' || 'sacado' || 'investidor';
  @Output() onRequestUser = new EventEmitter();

  cedenteRecebiveis: any;
  cedenteOperacional: any;

  constructor(
    private dataService: DataService,
    private router: Router,
    private usuarioService: UsuarioService,
    private _snackBar: MatSnackBar
  ) {
    this.requestOpcoesUser();
  }

  ngOnInit() {}

  init() {
    switch (this.visao) {
      case 'cedente':
        this.menus = this.dataService.menus;
        break;
      case 'sacado':
        this.menus = this.dataService.menuSacado;
        break;
      case 'investidor':
        this.menus = this.dataService.menuInvestidor;
        break;
    }

    this.router.events.subscribe((result) => {
      if (result instanceof NavigationEnd) {
        this.configureMenu();
      }
    });

    this.configureMenu();
  }

  marcaMenu(menu: any) {
    this.menuPage.map((m: any) => {
      m.active = false;
    });

    menu.active = true;
  }

  actionMenu(menu: any) {
    this.marcaMenu(menu);

    if (!menu.desabilitar) this.router.navigate([menu.rota]);
  }

  getIcon(icon: any) {
    return this.listIcons[icon] || this.listIcons.faQuestion;
  }

  requestOpcoesUser() {
    this.usuarioService
      .obterUsuarioComOpcoes()
      .then((user: any) => {
        switch (user.tipoUsuario) {
          case 'CEDENTE':
            this.visao = 'cedente';
            break;
          case 'SACADO':
            this.visao = 'sacado';
            break;
          case 'INVESTIDOR':
            this.visao = 'investidor';
            break;
        }

        this.onRequestUser.emit(this.visao);
        this.init();
      })
      .catch((error) => {
        console.error('error', error);
        this._snackBar.open('Ocorreu um erro, tente novamente.', 'Ok');
      });
  }

  permissaoVisibilidade() {
    this.menuPage = this.menuPage.filter(
      (item: any) =>
        item.descricao !== 'Dashboard' && item.descricao !== 'Conta gráfica'
    );
  }

  configureMenu() {
    let urlCurrentPath = this.router.url.split('/')[1];
    let urlCurrent = this.router.url;

    this.menus.forEach((m: any) => {
      let menuPath = m.rota.split('/')[1];

      if (urlCurrentPath === menuPath) {
        this.menuPage = [];

        m.itens.map((x: any) => {
          x.id = x.rota.split('/')[2];
        });

        this.menuPage = m.itens;
      }
    });

    this.menuPage.map((m: any) => {
      m.active = false;
    });

    this.menuPage.forEach((m: any) => {
      if (urlCurrent.indexOf(m.rota) != -1) {
        m.active = true;
      }
    });
  }
}
